import {FormEvent} from 'react';
import {Button} from '@shipwell/shipwell-ui';
import {FlexBox} from 'App/components/Box';

export const SharedStartEndpointFooter = ({
  onClose,
  isAddingOrdersToShipment,
  selectedOrderIds,
  handleSubmit,
  setIsModifyingOrders
}: {
  onClose: () => void;
  isAddingOrdersToShipment: boolean;
  selectedOrderIds: string[];
  handleSubmit: ((e?: FormEvent<HTMLFormElement> | undefined) => void) | undefined;
  setIsModifyingOrders: (Arg0: boolean) => void;
}) => (
  <FlexBox justify="between" gap="m">
    <Button variant="tertiary" iconName="ArrowBack" onClick={() => setIsModifyingOrders(false)}>
      Back
    </Button>
    <FlexBox justify="between" gap="m">
      <Button onClick={onClose} variant="secondary">
        Cancel
      </Button>
      <Button
        variant="primary"
        isLoading={isAddingOrdersToShipment}
        disabled={!selectedOrderIds.length}
        onClick={() => handleSubmit?.()}
      >
        Add to Shipment
      </Button>
    </FlexBox>
  </FlexBox>
);
